function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { registerAction, unregisterAction } from 'helpers/reducerTools';
import { SIGN_OUT_SUCCESS } from 'modules/Account/actionTypes';
import * as actionTypes from './actionTypes';
const initialState = {
    organizationUID: null,
    organizationMemberships: null,
    fetching: [],
    sending: [],
    errors: []
};
export default function reducer(state = _object_spread({}, initialState), action = {}) {
    switch(action.type){
        case actionTypes.FETCH_ORGANIZATION_MEMBERSHIPS:
            {
                const { organizationUID } = action.payload;
                return _object_spread_props(_object_spread({}, state), {
                    organizationUID,
                    fetching: registerAction(state.fetching, actionTypes.FETCH_ORGANIZATION_MEMBERSHIPS),
                    errors: unregisterAction(state.errors, actionTypes.FETCH_ORGANIZATION_MEMBERSHIPS)
                });
            }
        case actionTypes.FETCH_ORGANIZATION_MEMBERSHIPS_SUCCESS:
            {
                const { organizationMemberships } = action.payload;
                return _object_spread_props(_object_spread({}, state), {
                    organizationMemberships,
                    fetching: unregisterAction(state.fetching, actionTypes.FETCH_ORGANIZATION_MEMBERSHIPS)
                });
            }
        case actionTypes.FETCH_ORGANIZATION_MEMBERSHIPS_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    fetching: unregisterAction(state.fetching, actionTypes.FETCH_ORGANIZATION_MEMBERSHIPS),
                    errors: registerAction(state.errors, actionTypes.FETCH_ORGANIZATION_MEMBERSHIPS)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.APPROVE_MEMBERSHIP:
        case actionTypes.REJECT_MEMBERSHIP:
        case actionTypes.DELETE_MEMBERSHIP:
        case actionTypes.CREATE_INVITATION:
        case actionTypes.CANCEL_INVITATION:
        case actionTypes.RESEND_INVITATION:
        case actionTypes.GRANT_ADMIN:
        case actionTypes.REVOKE_ADMIN:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: registerAction(state.sending, action.type),
                    errors: unregisterAction(state.errors, action.type)
                });
            }
        case actionTypes.APPROVE_MEMBERSHIP_SUCCESS:
        case actionTypes.GRANT_ADMIN_SUCCESS:
        case actionTypes.REVOKE_ADMIN_SUCCESS:
            {
                const mainActionType = action.type.slice(0, -8);
                const { organizationMembership } = action.payload;
                const { organizationMemberships } = state;
                const idx = organizationMemberships.findIndex((om)=>om.identityUID === organizationMembership.identityUID && om.organizationUID === organizationMembership.organizationUID);
                if (idx >= 0) {
                    organizationMemberships[idx] = organizationMembership;
                }
                return _object_spread_props(_object_spread({}, state), {
                    organizationMemberships,
                    sending: unregisterAction(state.sending, mainActionType)
                });
            }
        case actionTypes.CREATE_INVITATION_SUCCESS:
        case actionTypes.RESEND_INVITATION_SUCCESS:
            {
                const mainActionType = action.type.slice(0, -8);
                return _object_spread_props(_object_spread({}, state), {
                    sending: unregisterAction(state.sending, mainActionType)
                });
            }
        case actionTypes.REJECT_MEMBERSHIP_SUCCESS:
        case actionTypes.DELETE_MEMBERSHIP_SUCCESS:
        case actionTypes.CANCEL_INVITATION_SUCCESS:
            {
                const mainActionType = action.type.slice(0, -8);
                const { organizationMembership } = action.payload;
                const organizationMemberships = state.organizationMemberships.filter((om)=>om.identityUID !== organizationMembership.identityUID);
                return _object_spread_props(_object_spread({}, state), {
                    organizationMemberships,
                    sending: unregisterAction(state.sending, mainActionType)
                });
            }
        case actionTypes.APPROVE_MEMBERSHIP_ERROR:
        case actionTypes.REJECT_MEMBERSHIP_ERROR:
        case actionTypes.DELETE_MEMBERSHIP_ERROR:
        case actionTypes.CREATE_INVITATION_ERROR:
        case actionTypes.CANCEL_INVITATION_ERROR:
        case actionTypes.RESEND_INVITATION_ERROR:
        case actionTypes.GRANT_ADMIN_ERROR:
        case actionTypes.REVOKE_ADMIN_ERROR:
            {
                const mainActionType = action.type.slice(0, -6);
                return _object_spread_props(_object_spread({}, state), {
                    sending: unregisterAction(state.sending, mainActionType),
                    errors: registerAction(state.errors, mainActionType)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.CLEAR_ORGANIZATION:
        case SIGN_OUT_SUCCESS:
            {
                return _object_spread({}, initialState);
            }
        //------------------------------------------------------------------------------------------------------------------
        default:
            {
                return state;
            }
    }
}
